import { MouseEvent } from 'react';
import { useInView } from 'react-intersection-observer';

import { AdBannerBaseProps } from '../types/AdBannerBaseProps';

interface Config<T, K> extends AdBannerBaseProps<K> {
  onClick?: (e: MouseEvent<T>) => void;
}

export const useUblHandler = <T extends HTMLElement, K>({ item, ubl_handler, onClick }: Config<T, K>) => {
  const { ref } = useInView({
    onChange: (in_view) => in_view && ubl_handler?.impression?.(item),
  });

  const handleClick = (e: MouseEvent<T>) => {
    ubl_handler?.click?.(item);
    onClick?.(e);
  };

  const bind = () => ({
    ref,
    onClick: handleClick,
  });

  return { bind };
};
